import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private counter: number;

  constructor() {
    this.counter = 0;
  }

  present(): void {
    this.counter++;
  }

  dismiss(): void {
    if (this.counter > 0) {
      this.counter--;
    }
  }

  dismissAll(): void {
    setTimeout(() => {
      this.counter = 0;
    }, 100);
  }

  isVisible(): boolean {
    return this.counter > 0;
  }
}
